var React = require('react');

function Twitter32 (props) {
    return React.createElement("svg",props,[React.createElement("metadata",{"key":0}),React.createElement("defs",{"key":1},React.createElement("style",null,"\n      .cls-1 {\n        fill: #7e8082;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"Twitter_32","className":"cls-1","d":"M1694.01,57a16,16,0,1,1-16,16A16,16,0,0,1,1694.01,57Zm10.26,10.285-1.92,1.958s0.32,11.544-11.21,11.748c-4.76.163-6.08-1.958-6.08-1.958s3.48,0.816,5.76-1.305a3.992,3.992,0,0,1-3.84-3.263,2.164,2.164,0,0,0,1.92.326c0-.142-3.34-0.714-3.2-4.242a2.4,2.4,0,0,0,1.92.653s-3.38-2.285-1.28-5.548c3.77,4.718,7.91,4.5,8.3,4.565a3.76,3.76,0,0,1-.3-1.465A3.718,3.718,0,0,1,1698.02,65a3.642,3.642,0,0,1,2.97,1.548c0.24-.148.4-0.243,0.4-0.243l2.56-.979-1.92,2.284Z","transform":"translate(-1678 -57)","key":2})]);
}

Twitter32.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Twitter32;

Twitter32.default = Twitter32;
